import { Nullable } from 'models/helpers'
import { PropertyAddressDTO } from 'models/property'

/** Street line of a property address (`street streetNumber`), falling back to the city */
export const getStreetAddressLine = (address: Nullable<PropertyAddressDTO>): string => {
  if (!address) return ''

  const streetLine = [address.street, address.streetNumber].map(part => part?.trim()).filter(Boolean).join(' ')

  return streetLine || address.city?.trim() || ''
}
